import React from 'react';
import { AccentLabel } from 'smartsuite-ui';
import PropTypes, { func } from 'prop-types';

export default function BagDetail(props) {
    const value = props.item.value || '-';

    return (
        <div className="bag-detail">
            <AccentLabel>{props.item.key}</AccentLabel>
            {props.item.link ? (
                <a
                    href={props.item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {value}
                </a>
            ) : (
                <div>{value}</div>
            )}
        </div>
    );
}

BagDetail.propTypes = {
    item: PropTypes.instanceOf(Object),
};
